import { ArticleHeading1, ArticleHeading4 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './NewbuildingMapWrapper.css';
import { NearbyNewbuildingsLinkContainer } from '../../containers/NearbyNewbuildingsLinkContainer';
import { SpecialPromoLinkContainer } from '../../containers/SpecialPromoLinkContainer';

export interface INewbuildingMapWrapperProps {
  redesignPage: boolean;
  children: React.ReactNode;
}

export const NewbuildingMapWrapper: React.FC<INewbuildingMapWrapperProps> = ({ redesignPage, children }) => {
  return (
    <section className={cn(styles['wrapper'], !redesignPage && styles['with-border'])} id="map">
      <div className={cn(styles['header'], !redesignPage && styles['with-padding'])}>
        {redesignPage ? (
          <ArticleHeading1 as="h1" fontWeight="bold">
            Инфраструктура
          </ArticleHeading1>
        ) : (
          <ArticleHeading4 as="h3" fontWeight="bold">
            Инфраструктура
          </ArticleHeading4>
        )}
        <div className={styles['links']}>
          <SpecialPromoLinkContainer />
          <NearbyNewbuildingsLinkContainer />
        </div>
      </div>
      {children}
    </section>
  );
};
